import React from 'react';
import { useField } from 'formik';
import RadioField from './index.js';

import './index.sass';

const FormikRadioField = ({ className, name, ...rest }) => {

    const [field, meta, helpers] = useField({ name, type: 'radio' });

    return <RadioField
        {...field}
        checked={meta.value === rest.value}
        className={className}
        error={meta.error}
        {...rest}
    />
}

export default FormikRadioField;
